import TestFlowViewSelectRecordPanelV2 from 'automation-ui-canvas/containers/flow-views/test-flow/TestFlowViewSelectRecordPanelV2';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-enrollment/queries/ObjectTypesQueries';
import { useQuery } from 'data-fetching-client';
import { useHistory } from 'react-router-dom';
import TestFlowViewSimulatePanel from 'automation-ui-canvas/containers/flow-views/test-flow/TestFlowViewSimulatePanel';
import { RECORD_ID_QUERY_PARAM } from 'automation-ui-canvas/containers/flow-views/test-flow/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const TestFlowSidePanel = props => {
  const history = useHistory();
  const searchParams = new URLSearchParams(history.location.search);
  const {
    data: objectTypeResponse
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    variables: {
      objectTypeId: props.flow.objectTypeId
    }
  });
  const objectTypeDefinition = objectTypeResponse === null || objectTypeResponse === void 0 ? void 0 : objectTypeResponse.enrollment_objectTypeById;
  if (!objectTypeDefinition) {
    return null;
  }
  if (searchParams.get(RECORD_ID_QUERY_PARAM)) {
    return /*#__PURE__*/_jsx(TestFlowViewSimulatePanel, Object.assign({
      recordId: parseInt(searchParams.get(RECORD_ID_QUERY_PARAM), 10)
    }, props));
  }
  return /*#__PURE__*/_jsx(TestFlowViewSelectRecordPanelV2, Object.assign({
    objectTypeDefinition: objectTypeDefinition
  }, props));
};
export default TestFlowSidePanel;